import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import useApiRequest from '../../store/slices/hook/useApiRequest';
import Button from '../common/Button';
import Input from '../common/Input';
import { selectPartnerSlide, setSelectedPartner, togglePartnerSlide } from '../../store/slices/common';
import SlideOver from '../SlideOver';
import { createPartner, updatePartner } from '../../store/slices/api/inner/partnerSlice';

const PartnerForm = ({
    defaultData,
    fetchData,
}) => {

    const PartnerIsOpen = useSelector(selectPartnerSlide);
    const dispatch = useDispatch();
    const [file, setFile] = useState(null);

    const defaultValues = {
        partnerName: defaultData?.partner_name ?? "",
    }

    const afterAPICall = (response) => {
        fetchData()
        dispatch(togglePartnerSlide())
        dispatch(setSelectedPartner(null))
    }

    const beforeAPICall = (data) => {
        const formData = new FormData();
        formData.append('partnerName', data?.partnerName);
        if (file) {
            formData.append('logo', file);
        }
        return {
            success: true,
            refactoredData: {
                formData,
                query: {
                    partnerId: defaultData?.partner_id,
                },
            }
        }
    }
    const { isLoading, control, handleSubmit, setValue } = useApiRequest({
        apiAction: defaultData ? updatePartner : createPartner,
        defaultValues,
        clearForm: true,
        beforeAPICall,
        afterAPICall,
    });

    useEffect(() => {
        if (defaultData) {
            setValue('partnerName', defaultData?.partner_name ?? "");
        } else {
            setValue('partnerName', "");
        }
    }, [defaultData, setValue]);


    return (
        <SlideOver isOpen={PartnerIsOpen} toggleOpen={togglePartnerSlide} panelName={defaultData ?  "Update Partner":"Add Partner" }>
            <form onSubmit={handleSubmit}>
                <Input
                    control={control}
                    name="partnerName"
                    rules={{
                        required: "this field is required"
                    }}
                    label="partner name"
                />
                <Input
                    control={control}
                    type='file'
                    name="logo"
                    onChange={(event) => { setFile(event.target.files ? event.target.files[0] : null) }}
                    label="logo"
                />

                <div className="flex justify-end my-6">
                    <Button isLoading={isLoading}>
                        {defaultData ? "Save changes" : "Submit"}
                    </Button>
                </div>
            </form>
        </SlideOver>
    )
}

export default PartnerForm